import { IIconProps } from '~/types';

const InvoiceIcon = ({ fill = '#7B7986', size = 24, ...props }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m9.5 14 6-6m-5.5.5h.01m4.99 5h.01M20.5 21V5a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v16l4-2 4 2 4-2zm-10-12.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m5 5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
      stroke={fill}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default InvoiceIcon;
